import { api } from "./apiClient";

export interface ProjectLastEditorResponse {
  user: { name: string | null };
  createdAt: string | null;
}

export class AuditService {
    static async getByProjectAndArea(params: any): Promise<any> {
        return api.get('/audit/search', {params}).then((response) => response.data)
    }

    static async getAuditsByFilter(
        project?: string,
        user?: string,
        area?: string,
        action?: string
    ): Promise<any> {
        const params: any = {};
        if (project) params.project = project;
        if (user) params.user = user;
        if (area) params.area = area;
        if (action) params.action = action;
        
        return api.get('/audit/search', { params }).then((response) => response.data);
    }

    static async getServiceAuditsByBudget(
        budgetId: string,
        serviceType?: 'budget' | 'negotiation' | 'closing'
    ): Promise<any> {
        const params: any = {};
        if (serviceType) params.serviceType = serviceType;
        
        return api.get(`/audit/services/budget/${budgetId}`, { params }).then((response) => response.data);
    }

    static async getServiceAuditsByServiceId(
        serviceId: string
    ): Promise<any> {
        return api.get(`/audit/services/service/${serviceId}`).then((response) => response.data);
    }

    static async getProjectLastEditor(
        projectId: string,
    ): Promise<ProjectLastEditorResponse> {
        return api
            .get(`/audit/projects/${projectId}/last-editor`)
            .then((response) => response.data);
    }
}

// Export as instance for convenience
export const auditService = {
    getByProjectAndArea: AuditService.getByProjectAndArea,
    getAuditsByFilter: AuditService.getAuditsByFilter,
    getServiceAuditsByBudget: AuditService.getServiceAuditsByBudget,
    getServiceAuditsByServiceId: AuditService.getServiceAuditsByServiceId,
    getProjectLastEditor: AuditService.getProjectLastEditor,
};